export const parseBetaUrl = (data) => {
  if (location.hostname.indexOf("appbeta") < 0) {
    return data;
  }

  // 需要匹配的域名列表
  const domains = [
    "//s1.tuchong.com",
    "//photo.tuchong.com",
    "//api.tuchong.com",
    "//m.tuchong.com",
    "//ws.tuchong.com",
    "//tuchong.com",
  ];

  const needAppbetaDomain = (value) => {
    const domain = domains.find((item) => value.indexOf(item) > 0);
    return Boolean(domain);
  };

  const isString = (value) => {
    return typeof value === "string";
  };

  const isJSON = (value) => {
    return typeof value === "object" && value !== null;
  };

  const isArray = (value) => {
    return Object.prototype.toString.call(value) === "[object Array]";
  };

  const toBetaDomain = (value) => {
    // 三级域名
    if (needAppbetaDomain(value)) {
      return value.replace("tuchong.com", "appbeta.tuchong.com");
    }
    return value;
  };

  const parseBetaData = (raw) => {
    // 字符串进行处理
    if (isString(raw)) {
      return toBetaDomain(raw);
    }

    // 数字递归
    if (isArray(raw)) {
      return raw.map((item) => parseBetaData(item));
    }

    // json 递归
    if (isJSON(raw)) {
      const res = {};
      Object.keys(raw).forEach((key) => {
        if (raw.hasOwnProperty(key)) {
          res[key] = parseBetaData(raw[key]);
        }
      });
      return res;
    }

    // 其他类型直接返回
    return raw;
  };

  return parseBetaData(data);
};
